import React, { useEffect } from 'react';
import { useActiveClassData, useProfile } from '../state/hooks';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { isNullOrEmpty } from '../../utils/arrays';
import { PageSkeleton } from '../Skeleton';
import { canViewCurrentTasks, canViewFeedbackRequests, canViewJeddAI } from '../../utils/userAccessHelper.js';

const Dashboard = ({ role }) => {
  const { data: classData, isLoadingdata: isLoadingclassData } = useActiveClassData();
  const history = useHistory();
  const { data: profile, isLoadingdata: isLoadingProfile } = useProfile();

  useEffect(() => {
    // Only navigate once data is loaded
    if (isLoadingclassData || isLoadingProfile) return;

    if (!isNullOrEmpty(classData) && canViewCurrentTasks(profile)) {
      history.push('/tasks');
    } else if (canViewFeedbackRequests(profile)) {
      history.push('/giveFeedback');
    } else if (canViewJeddAI(profile)) {
      history.push('/getFeedback');
    } else {
      history.push('/docs');
    }
  }, [classData, isLoadingclassData, isLoadingProfile, profile, history]);

  if (isLoadingclassData || isLoadingProfile) {
    return <PageSkeleton />;
  }

  return <></>;
};

export default Dashboard;
